import styled from "styled-components";
import COLORS from "styles/colors";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background: ${({ bg }) => bg};
  @media all and (max-width: 768px) {
    display: none;
  }
  .wrapper {
    margin: 10rem 9rem;
    width: 100%;
    .header {
      text-align: center;
      margin-bottom: 8rem;
      span {
        letter-spacing: 0.15em;
        font-size: 1.4rem;
        line-height: 1.7rem;
        margin-bottom: 12px;
      }
      .title {
        font-size: 3.6rem;
        line-height: 4.5rem;
        padding: 0 0.2rem;
      }
    }
    .cards {
      margin: 32px 0;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 0 15px;
      .card {
        width: 396px;
        min-height: 278px;
        background: ${COLORS.white};
        border: 0.5px solid #f0f8ff;
        border-radius: 12px;
        margin: 5px auto;
        opacity: 1;
        .card-content {
          margin: 3.4rem 5.4rem;
          .svg-wrapper {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            /* background: #f0f8ff; */
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 12px 0;
            svg {
              width: 30px;
            }
          }
          span {
            font-size: 1rem;
            line-height: 12px;
            letter-spacing: 0.15em;
          }
          .step-text {
            font-size: 2.1rem;
            margin: 8px 0;
            font-weight: 400;
          }
          p {
            font-size: 1.5rem;
            line-height: 24px;
            color: #464646;
          }
        }
      }
    }
  }
`;

export const SlideContainer = styled.div`
  width: 100%;
display: none;

@media all and (max-width: 768px){
  display: block;
}
  .slide-container {
    width: 50%;

    .header {
      text-align: center;
      /* margin-bottom: 8rem; */
      margin: 5rem 0;
      span {
        letter-spacing: 0.15em;
        font-size: 1.4rem;
        line-height: 1.7rem;
        margin-bottom: 12px;
      }
      .title {
        font-size: 3.6rem;
        line-height: 4.5rem;
        padding: 0 0.2rem;
      }
    }
    /* .slick-slider.slick-initialized {
      button {
       
      }
    } */
    .slick-slider.slick-initialized .slick-dots {
      > li button {
        background: #fff;
        height: 5px;
        width: 5px;
        border-radius: 50%;
        border: 1px solid #b5ceff;
        color: ${COLORS.white};
        font-size: 0;
        transform: none;
        ::before {
          content: "";
        }
      }
      .slick-active button {
        background: ${COLORS.primaryBackground};
        border: none;
      }
    }

    @media all and (max-width: 1024px) {
      width: 100%;
      padding: 9rem 0;
      background: ${({ bg }) => bg};
    }
  }
`;

export const StepsWrapper = styled.div`
  @media all and (max-width: 768px) {
    padding: 0 1rem;
  }


  .card {
    max-width: 496px;
    min-height: 278px;
    background: ${COLORS.white};
    border: 0.5px solid #f0f8ff;
    border-radius: 12px;
    margin: 5px auto;
    opacity: 1;

    .card-content {
      margin: 3.4rem 5.4rem;
      .svg-wrapper {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        /* background: #f0f8ff; */
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 12px 0;
        svg {
          width: 30px;
        }
      }
      span {
        font-size: 1rem;
        line-height: 12px;
        letter-spacing: 0.15em;
      }
      .step-text {
        font-size: 2.1rem;
        margin: 8px 0;
        font-weight: 400;
      }
      p {
        font-size: 1.5rem;
        line-height: 24px;
        color: #464646;
      }
    }
  }
`;

